// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LatestReviews-module__scene-latest-reviews--xojJR {
  display: inline-block;
  width: 464px;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  color: white;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
}

.LatestReviews-module__latest-reviews-title--_GM6A {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px;
}

.LatestReviews-module__latest-reviews-title--_GM6A h1 {
  font-size: 20px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/pages/IntroPage/components/LatestReviews/LatestReviews.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".scene-latest-reviews {\n  display: inline-block;\n  width: 464px;\n  max-height: calc(100vh - 80px);\n  overflow-y: auto;\n  color: white;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.latest-reviews-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 32px;\n}\n\n.latest-reviews-title h1 {\n  font-size: 20px;\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scene-latest-reviews": `LatestReviews-module__scene-latest-reviews--xojJR`,
	"latest-reviews-title": `LatestReviews-module__latest-reviews-title--_GM6A`
};
export default ___CSS_LOADER_EXPORT___;
